
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moving",
      function () {
        return require("private-next-pages/moving/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moving"])
      });
    }
  